/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface ScreeningMetricSessionDto
 */
export interface ScreeningMetricSessionDto {

    /**
     * Groups this session’s ROM value with its VAS pre/post pair.
     *
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example a8c85a1e-670c-4825-ac1c-714235e4e085
     */
    attemptId: string;

    /**
     * When the ROM item of this attempt was recorded.
     *
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example 2026-09-08T10:56:32.938Z
     */
    timestamp: string;

    /**
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example UPPER_ARM
     */
    district: ScreeningMetricSessionDtoDistrictEnum;

    /**
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example LEFT
     */
    side: ScreeningMetricSessionDtoSideEnum;

    /**
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example FLEXION
     */
    movement?: ScreeningMetricSessionDtoMovementEnum;

    /**
     * Display name Unity sent for this test, when provided.
     *
     * @type {string}
     * @memberof ScreeningMetricSessionDto
     * @example Shoulder flexion left
     */
    exerciseName?: string;

    /**
     * ROM value in degrees.
     *
     * @type {number}
     * @memberof ScreeningMetricSessionDto
     * @example 165.5
     */
    rom: number;

    /**
     * VAS pain score before the test (0-10).
     *
     * @type {number}
     * @memberof ScreeningMetricSessionDto
     * @example 6
     */
    vasStart?: number;

    /**
     * VAS pain score after the test (0-10).
     *
     * @type {number}
     * @memberof ScreeningMetricSessionDto
     * @example 7
     */
    vasEnd?: number;

    /**
     * Gym load used during the test, in kg.
     *
     * @type {number}
     * @memberof ScreeningMetricSessionDto
     * @example 4
     */
    weightKg?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum ScreeningMetricSessionDtoDistrictEnum {
    ANKLE = 'ANKLE',
    UPPERARM = 'UPPER_ARM',
    LOWERARM = 'LOWER_ARM',
    SHOULDERWIDTH = 'SHOULDER_WIDTH',
    TRUNK = 'TRUNK',
    WAIST = 'WAIST',
    UPPERLEG = 'UPPER_LEG',
    LOWERLEG = 'LOWER_LEG',
    BODY = 'BODY'
}
/**
 * @export
 * @enum {string}
 */
export enum ScreeningMetricSessionDtoSideEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    BOTH = 'BOTH'
}
/**
 * @export
 * @enum {string}
 */
export enum ScreeningMetricSessionDtoMovementEnum {
    FLEXION = 'FLEXION',
    EXTENSION = 'EXTENSION',
    ABDUCTION = 'ABDUCTION',
    ADDUCTION = 'ADDUCTION',
    ROTATION = 'ROTATION'
}

